module.exports = __webpack_public_path__ + "img/sent_box.0c36b3cb.svg";